<div [hidden]="!isBusy">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<mat-card class="content-card" *ngIf="revolutTransactionLeg">
  <mat-card-header>

  </mat-card-header>
  <mat-card-content>

    <div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">
      <div fxFlex="50">
        <h3><span (click)="returnBack()" style="cursor: pointer">◀️</span> {{revolutTransactionLeg.targetTypeName}} Transaction - {{ revolutTransactionLeg.transactionDate | date: "dd.MM.yyyy HH:mm" }}</h3>
      </div>
      <div fxFlex="50" style="text-align: right">

        <ng-container *ngIf="revolutTransactionLeg.targetTypeName == 'Revolut'">
          <img alt="revolut logo" src="assets/img/thirdparty-logos/revolut-logo.png" height="50" />
        </ng-container>
        <ng-container *ngIf="revolutTransactionLeg.targetTypeName == 'Qonto'">
          <img alt="revolut logo" src="assets/img/thirdparty-logos/qonto-logo.jpeg" height="50" />
        </ng-container>

        <div>
        Account ID: {{revolutTransactionLeg.accountId}}
        </div>
        <div>
          Transaction State: {{getRevolutTransactionStateText(revolutTransactionLeg.transactionState)}}
        </div>
      </div>
    </div>

    <div *ngIf="revolutTransactionLeg">

      <ng-container *ngIf="revolutTransactionLeg.isDebtCollectionPayment">
        <div style="margin-left: 8px; background-color: yellow; border: 1px solid orange; padding: 5px 3px; border-radius: 5px;">
          ⚠️ This is a payment from a collection agency. Linking an invoice will mark it as paid.
        </div>
      </ng-container>
      <ng-container *ngIf="(revolutTransactionLeg.possibleFirstname != null || revolutTransactionLeg.possibleLastname != null)">
        <div style="margin-top: 10px; margin-left: 8px; padding: 5px; background-color: lightskyblue; border-radius: 5px; border: 1px solid dodgerblue">
          <strong>Possible Name:</strong> {{ revolutTransactionLeg.possibleFirstname != null ? revolutTransactionLeg.possibleFirstname : "" }} {{ revolutTransactionLeg.possibleLastname != null ? revolutTransactionLeg.possibleLastname : "" }}
        </div>
      </ng-container>

      <div style="margin-top: 10px; max-width: 680px; margin-left: 15px;" >
        <div class="list-item" fxLayout="row" *ngFor="let field of fields">
          <label fxFlex="35" class="secondary">{{ field.header }}</label>

          <label fxFlex="65"
                 *ngIf="!(field.cell(revolutTransactionLeg).startsWith('&lt;a') || field.cell(revolutTransactionLeg).startsWith('&lt;i'))">
            {{ field.cell(revolutTransactionLeg) }}
          </label>

        </div>
      </div>
    </div>



    <div style="margin-left: 20px; margin-right: 20px; margin-top: 20px;">


          <div *ngIf="revolutTransactionLeg && revolutTransactionLeg.invoiceFound == null">
            <b>Invoice 1: </b>
            <mat-form-field>
              <input matInput type="text" [(ngModel)]="invSearch1" (keydown.enter)="onSearchInv1()"/>
            </mat-form-field>
            <button mat-icon-button (click)="onSearchInv1()" [disabled]="invSearch1 == null || (invSearch1 != null && invSearch1.length <= 3)">
              <mat-icon>search</mat-icon>
            </button>
            <div [hidden]="!invSearch1Loading">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
            <div *ngIf="invs1Found" style="min-height: 150px; max-height: 250px; overflow: auto">
              <table class="list-table" style="word-wrap:break-word; table-layout: fixed;">
                <tr>
                  <th class="" style="text-align: left; width: 60px;"><label></label></th>
                  <th class="" style="text-align: left; width: 120px;"><label>#</label></th>
                  <th style="text-align: left;"><label>Customer</label></th>
                  <th style="text-align: left; width: 120px;"><label>Type</label></th>
                  <th style="text-align: right; width: 90px;"><label>Amount</label></th>
                  <th style="text-align: right; width: 90px;"><label>Paid</label></th>
                  <th style="text-align: right; width: 90px;"><label>Outstanding</label></th>

                </tr>
                <tr *ngFor="let inv of invs1Found">
                  <td>
                    <!--<mat-checkbox [(ngModel)]="inv1MarkedAsPaid"> mark as paid</mat-checkbox>&nbsp;&nbsp;-->
                    <button [disabled]="isBusy" mat-icon-button color="primary" (click)="linkInvoice(inv.id, 1)">
                      <mat-icon>link</mat-icon>
                    </button>
                  </td>
                  <td><a [routerLink]="'/invoices/' + inv.id">{{ inv.code }}</a><br /><span *ngIf="inv.archived"><span style="color: red;">(archived)</span></span></td>
                  <td>
                    <div *ngIf="inv.customer">
                      {{ inv.customer.firstName }} {{ inv.customer.lastName }}, {{ inv.customer.address }}
                      , {{ inv.customer.zipCode }} {{ inv.customer.city }}
                    </div>
                  </td>
                  <td>{{ inv.invoiceTypeName }}
                    <div *ngIf="inv.debtorDistributionId != null && inv.debtorIdPairFinance == null"> / Cash Bro</div>
                    <div *ngIf="inv.debtorDistributionId != null && inv.debtorIdPairFinance != null"> / Pair Finance</div>
                    <div *ngIf="inv.debtorDistributionId != null && inv.debtorIdCulpa != null"> / Culpa</div>
                  </td>
                  <td style="text-align: right;">€ {{ inv.billAmount | number: '1.2-2' }}</td>
                  <td style="text-align: right;">€ {{ inv.paidAmount | number: '1.2-2' }}</td>
                  <td style="text-align: right;">€ {{ inv.outstandingAmount | number: '1.2-2' }}</td>

                </tr>
              </table>

            </div>
          </div>
          <div *ngIf="revolutTransactionLeg && revolutTransactionLeg.invoiceFound != null">

            <div style="display: inline-block; padding: 5px; background-color: lightgray; border: 1px dashed #666666;">
              <b>Linked Invoice:</b><br />

              <a [routerLink]="'/invoices/' + revolutTransactionLeg.invoiceFound.id"> {{ revolutTransactionLeg.invoiceFound.code }}</a>
              <span *ngIf="revolutTransactionLeg && revolutTransactionLeg.invoiceFound.archived">
              - <span style="color: red;">archived</span>
              </span>
              -
              <ng-container *ngIf="revolutTransactionLeg.invoiceFound.paidAmount != revolutTransactionLeg.invoiceFound.billAmount">
                € {{ revolutTransactionLeg.invoiceFound.paidAmount | number: '1.2-2' }} /
              </ng-container>

              € {{ revolutTransactionLeg.invoiceFound.billAmount | number: '1.2-2' }}
              -
              {{ revolutTransactionLeg.invoiceFound.paid ? '✅ marked as paid':'' }}

              &nbsp;&nbsp;&nbsp;&nbsp;
              <button [disabled]="isBusy" mat-icon-button color="warn" (click)="unlinkInvoice(revolutTransactionLeg.invoiceFound.id, 1)"><mat-icon>delete</mat-icon></button>
            </div>
          </div>






          <div *ngIf="revolutTransactionLeg && revolutTransactionLeg.invoiceFound2 == null">
            <b>Invoice 2: </b>
            <mat-form-field>
              <input matInput type="text" [(ngModel)]="invSearch2"  (keydown.enter)="onSearchInv2()" />
            </mat-form-field>
            <button mat-icon-button (click)="onSearchInv2()" [disabled]="invSearch2 == null || (invSearch2 != null && invSearch2.length <= 3)">
              <mat-icon>search</mat-icon>
            </button>
            <div [hidden]="!invSearch2Loading">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
            <div *ngIf="invs2Found" style="min-height: 150px; max-height: 250px; overflow: auto">
              <table class="list-table" style="word-wrap:break-word; table-layout: fixed;">
                <tr>
                  <th class="" style="text-align: left; width: 60px;"><label></label></th>
                  <th class="" style="text-align: left; width: 120px;"><label>#</label></th>
                  <th style="text-align: left;"><label>Customer</label></th>
                  <th style="text-align: left; width: 120px;"><label>Type</label></th>
                  <th style="text-align: right; width: 90px;"><label>Amount</label></th>
                  <th style="text-align: right; width: 90px;"><label>Paid</label></th>
                  <th style="text-align: right; width: 90px;"><label>Outstanding</label></th>

                </tr>
                <tr *ngFor="let inv of invs2Found">
                  <td>
                    <!--<mat-checkbox [(ngModel)]="inv1MarkedAsPaid"> mark as paid</mat-checkbox>&nbsp;&nbsp;-->
                    <button [disabled]="isBusy" mat-icon-button color="primary" (click)="linkInvoice(inv.id, 2)">
                      <mat-icon>link</mat-icon>
                    </button>
                  </td>
                  <td><a [routerLink]="'/invoices/' + inv.id">{{ inv.code }}</a><br /><span *ngIf="inv.archived"><span style="color: red;">(archived)</span></span></td>
                  <td>
                    <div *ngIf="inv.customer">
                      {{ inv.customer.firstName }} {{ inv.customer.lastName }}, {{ inv.customer.address }}
                      , {{ inv.customer.zipCode }} {{ inv.customer.city }}
                    </div>
                  </td>
                  <td>{{ inv.invoiceTypeName }}
                    <div *ngIf="inv.debtorDistributionId != null && inv.debtorIdPairFinance == null"> / Cash Bro</div>
                    <div *ngIf="inv.debtorDistributionId != null && inv.debtorIdPairFinance != null"> / Pair Finance</div>
                    <div *ngIf="inv.debtorDistributionId != null && inv.debtorIdCulpa != null"> / Culpa</div>
                    <div *ngIf="inv.debtorDistributionId != null && inv.debtorIdTroy != null"> / Troy</div>
                  </td>
                  <td style="text-align: right;">€ {{ inv.billAmount | number: '1.2-2' }}</td>
                  <td style="text-align: right;">€ {{ inv.paidAmount | number: '1.2-2' }}</td>
                  <td style="text-align: right;">€ {{ inv.outstandingAmount | number: '1.2-2' }}</td>

                </tr>
              </table>

            </div>
          </div>
      <div *ngIf="revolutTransactionLeg && revolutTransactionLeg.invoiceFound2 != null">

        <div style="display: inline-block; padding: 5px; background-color: lightgray; border: 1px dashed #666666;">
          <b>Linked Invoice:</b><br />

          <a [routerLink]="'/invoices/' + revolutTransactionLeg.invoiceFound2.id"> {{ revolutTransactionLeg.invoiceFound2.code }}</a>
          <span *ngIf="revolutTransactionLeg && revolutTransactionLeg.invoiceFound2.archived">
              - <span style="color: red;">archived</span>
              </span>
          -
          <ng-container *ngIf="revolutTransactionLeg.invoiceFound2.paidAmount != revolutTransactionLeg.invoiceFound2.billAmount">
            € {{ revolutTransactionLeg.invoiceFound2.paidAmount | number: '1.2-2' }} /
          </ng-container>

          € {{ revolutTransactionLeg.invoiceFound2.billAmount | number: '1.2-2' }}
          -
          {{ revolutTransactionLeg.invoiceFound2.paid ? '✅ marked as paid':'' }}

          &nbsp;&nbsp;&nbsp;&nbsp;
          <button [disabled]="isBusy" mat-icon-button color="warn" (click)="unlinkInvoice(revolutTransactionLeg.invoiceFound2.id, 2)"><mat-icon>delete</mat-icon></button>
        </div>
      </div>





          <div *ngIf="revolutTransactionLeg && revolutTransactionLeg.invoiceFound3 == null">
            <b>Invoice 3: </b>
            <mat-form-field>
              <input matInput type="text" [(ngModel)]="invSearch3" (keydown.enter)="onSearchInv3()"  />
            </mat-form-field>
            <button mat-icon-button (click)="onSearchInv3()" [disabled]="invSearch3 == null || (invSearch3 != null && invSearch3.length <= 3)">
              <mat-icon>search</mat-icon>
            </button>
            <div [hidden]="!invSearch3Loading">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
            <div *ngIf="invs3Found" style="min-height: 150px; max-height: 250px; overflow: auto">
              <table class="list-table" style="word-wrap:break-word; table-layout: fixed;">
                <tr>
                  <th class="" style="text-align: left; width: 60px;"><label></label></th>
                  <th class="" style="text-align: left; width: 120px;"><label>#</label></th>
                  <th style="text-align: left;"><label>Customer</label></th>
                  <th style="text-align: left; width: 120px;"><label>Type</label></th>
                  <th style="text-align: right; width: 90px;"><label>Amount</label></th>
                  <th style="text-align: right; width: 90px;"><label>Paid</label></th>
                  <th style="text-align: right; width: 90px;"><label>Outstanding</label></th>

                </tr>
                <tr *ngFor="let inv of invs3Found">
                  <td>
                    <!--<mat-checkbox [(ngModel)]="inv1MarkedAsPaid"> mark as paid</mat-checkbox>&nbsp;&nbsp;-->
                    <button [disabled]="isBusy" mat-icon-button color="primary" (click)="linkInvoice(inv.id, 3)">
                      <mat-icon>link</mat-icon>
                    </button>
                  </td>
                  <td><a [routerLink]="'/invoices/' + inv.id">{{ inv.code }}</a><br /><span *ngIf="inv.archived"><span style="color: red;">(archived)</span></span></td>
                  <td>
                    <div *ngIf="inv.customer">
                      {{ inv.customer.firstName }} {{ inv.customer.lastName }}, {{ inv.customer.address }}
                      , {{ inv.customer.zipCode }} {{ inv.customer.city }}
                    </div>
                  </td>
                  <td>{{ inv.invoiceTypeName }}
                    <div *ngIf="inv.debtorDistributionId != null && inv.debtorIdPairFinance == null"> / Cash Bro</div>
                    <div *ngIf="inv.debtorDistributionId != null && inv.debtorIdPairFinance != null"> / Pair Finance</div>
                    <div *ngIf="inv.debtorDistributionId != null && inv.debtorIdCulpa != null"> / Culpa</div>
                  </td>
                  <td style="text-align: right;">€ {{ inv.billAmount | number: '1.2-2' }}</td>
                  <td style="text-align: right;">€ {{ inv.paidAmount | number: '1.2-2' }}</td>
                  <td style="text-align: right;">€ {{ inv.outstandingAmount | number: '1.2-2' }}</td>

                </tr>
              </table>

            </div>
          </div>
      <div *ngIf="revolutTransactionLeg && revolutTransactionLeg.invoiceFound3 != null">

        <div style="display: inline-block; padding: 5px; background-color: lightgray; border: 1px dashed #666666;">
          <b>Linked Invoice:</b><br />

          <a [routerLink]="'/invoices/' + revolutTransactionLeg.invoiceFound3.id"> {{ revolutTransactionLeg.invoiceFound3.code }}</a>
          <span *ngIf="revolutTransactionLeg && revolutTransactionLeg.invoiceFound3.archived">
              - <span style="color: red;">archived</span>
              </span>
          -
          <ng-container *ngIf="revolutTransactionLeg.invoiceFound3.paidAmount != revolutTransactionLeg.invoiceFound3.billAmount">
            € {{ revolutTransactionLeg.invoiceFound3.paidAmount | number: '1.2-2' }} /
          </ng-container>

          € {{ revolutTransactionLeg.invoiceFound3.billAmount | number: '1.2-2' }}
          -
          {{ revolutTransactionLeg.invoiceFound3.paid ? '✅ marked as paid':'' }}

          &nbsp;&nbsp;&nbsp;&nbsp;
          <button [disabled]="isBusy" mat-icon-button color="warn" (click)="unlinkInvoice(revolutTransactionLeg.invoiceFound3.id, 3)"><mat-icon>delete</mat-icon></button>
        </div>
      </div>



          <div *ngIf="revolutTransactionLeg && revolutTransactionLeg.invoiceFound4 == null">
            <b>Invoice 4: </b>
            <mat-form-field>
              <input matInput type="text" [(ngModel)]="invSearch4" (keydown.enter)="onSearchInv4()" />
            </mat-form-field>
            <button mat-icon-button (click)="onSearchInv4()" [disabled]="invSearch4 == null || (invSearch4 != null && invSearch4.length <= 3)">
              <mat-icon>search</mat-icon>
            </button>
            <div [hidden]="!invSearch4Loading">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
            <div *ngIf="invs4Found" style="min-height: 150px; max-height: 250px; overflow: auto">
              <table class="list-table" style="word-wrap:break-word; table-layout: fixed;">
                <tr>
                  <th class="" style="text-align: left; width: 60px;"><label></label></th>
                  <th class="" style="text-align: left; width: 120px;"><label>#</label></th>
                  <th style="text-align: left;"><label>Customer</label></th>
                  <th style="text-align: left; width: 120px;"><label>Type</label></th>
                  <th style="text-align: right; width: 90px;"><label>Amount</label></th>
                  <th style="text-align: right; width: 90px;"><label>Paid</label></th>
                  <th style="text-align: right; width: 90px;"><label>Outstanding</label></th>

                </tr>
                <tr *ngFor="let inv of invs4Found">
                  <td>
                    <!--<mat-checkbox [(ngModel)]="inv1MarkedAsPaid"> mark as paid</mat-checkbox>&nbsp;&nbsp;-->
                    <button [disabled]="isBusy" mat-icon-button color="primary" (click)="linkInvoice(inv.id, 4)">
                      <mat-icon>link</mat-icon>
                    </button>
                  </td>
                  <td><a [routerLink]="'/invoices/' + inv.id">{{ inv.code }}</a><br /><span *ngIf="inv.archived"><span style="color: red;">(archived)</span></span></td>
                  <td>
                    <div *ngIf="inv.customer">
                      {{ inv.customer.firstName }} {{ inv.customer.lastName }}, {{ inv.customer.address }}
                      , {{ inv.customer.zipCode }} {{ inv.customer.city }}
                    </div>
                  </td>
                  <td>{{ inv.invoiceTypeName }}
                    <div *ngIf="inv.debtorDistributionId != null && inv.debtorIdPairFinance == null"> / Cash Bro</div>
                    <div *ngIf="inv.debtorDistributionId != null && inv.debtorIdPairFinance != null"> / Pair Finance</div>
                    <div *ngIf="inv.debtorDistributionId != null && inv.debtorIdCulpa != null"> / Culpa</div>
                  </td>
                  <td style="text-align: right;">€ {{ inv.billAmount | number: '1.2-2' }}</td>
                  <td style="text-align: right;">€ {{ inv.paidAmount | number: '1.2-2' }}</td>
                  <td style="text-align: right;">€ {{ inv.outstandingAmount | number: '1.2-2' }}</td>

                </tr>
              </table>

            </div>
          </div>
      <div *ngIf="revolutTransactionLeg && revolutTransactionLeg.invoiceFound4 != null">

        <div style="display: inline-block; padding: 5px; background-color: lightgray; border: 1px dashed #666666;">
          <b>Linked Invoice:</b><br />

          <a [routerLink]="'/invoices/' + revolutTransactionLeg.invoiceFound4.id"> {{ revolutTransactionLeg.invoiceFound4.code }}</a>
          <span *ngIf="revolutTransactionLeg && revolutTransactionLeg.invoiceFound4.archived">
              - <span style="color: red;">archived</span>
              </span>
          -
          <ng-container *ngIf="revolutTransactionLeg.invoiceFound4.paidAmount != revolutTransactionLeg.invoiceFound4.billAmount">
            € {{ revolutTransactionLeg.invoiceFound4.paidAmount | number: '1.2-2' }} /
          </ng-container>

          € {{ revolutTransactionLeg.invoiceFound4.billAmount | number: '1.2-2' }}
          -
          {{ revolutTransactionLeg.invoiceFound4.paid ? '✅ marked as paid':'' }}

          &nbsp;&nbsp;&nbsp;&nbsp;
          <button [disabled]="isBusy" mat-icon-button color="warn" (click)="unlinkInvoice(revolutTransactionLeg.invoiceFound4.id, 4)"><mat-icon>delete</mat-icon></button>
        </div>
      </div>
        </div>



  </mat-card-content>

  <mat-card-actions align="start">
    <a mat-raised-button color="primary" (click)="returnBack()">Back</a>


    <button mat-raised-button color="primary" [disabled]="!prevNext?.prev" (click)="gotoPrevTrans()">Previous</button>
    <button mat-raised-button color="primary" [disabled]="!prevNext?.next" (click)="gotoNextTrans()">Next</button>

  </mat-card-actions>
</mat-card>
